
import React from "react";
import { BrowserRouter,Route,Routes } from "react-router-dom";
import Home from "./pages/HomePage";
import CallOut from "./pages/CallOut";


const App = ()=>{
  return(
  <BrowserRouter>
    <Routes>
        <Route path="/" element={<Home/>}/>
        <Route path="/callout" element={<CallOut/>}/>
    </Routes>
  </BrowserRouter>
  );
}

export default App;